import { inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { filter } from 'rxjs';
import { setUpGoogleAnalytics, trackFacebookPageView } from '../../features/jobs/utils/functions';

export function initAnalytics(): void {
  const router = inject(Router);
  const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  if (!isBrowser) return;

  router.events
    .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
    .subscribe((event) => {
      setUpGoogleAnalytics(event);
      trackFacebookPageView();
    });
}
